export const ACTION_LOAD_MORE_IN_TABLE = 'loadMoreInTable';

export const ACTION_ON_LOAD_MORE_ITEMS_SUCCESS = 'onLoadMoreItemsSucceeded';
export const ACTION_ON_LOAD_MORE_ITEMS_FAILURE = 'onLoadMoreRowsFailed';
export const ACTION_ON_LOAD_MORE_CONVERSATIONS_SUCCESS = 'onLoadMoreConversationsSucceeded';

export const ACTION_SELECT_FOCUSED_PIVOT = 'selectFocusedPivot';
